/** @jsx jsx */
// External Modules
import { jsx } from '@emotion/core';
import { useStoreState } from '@/store';
import type { ReactNode } from 'react';

// Internal modules
import { features, useMountLogging } from '@/lib';
import { Footer } from '../Footer';
// @ts-expect-error untyped import
import { Header } from '../Header';
import {
  EmotionWrapper,
  PageLoadingSpinner,
  PayPalValueProps,
} from './Components';
// @ts-expect-error - not converted until c3 is removed
import { AppWrapper, ContentWrapper, FlexWrapper } from './StyledComponents';

export interface LayoutProps {
  children?: ReactNode;
  isContentFullWidth?: boolean;
  pageName?: string;
  showFooter?: boolean;
  showHeader?: boolean;
  showValueProps?: boolean;
}

export const Layout = ({
  children,
  isContentFullWidth = false,
  pageName = 'unknown',
  showHeader = true,
  showFooter = true,
  showValueProps = true,
}: LayoutProps): JSX.Element => {
  useMountLogging('Layout');
  const hasRebrandFontTreatment = features.isActive('hasRebrandFontTreatment');

  const isPageLoading = useStoreState(state => state.ui.isPageLoading);

  // TODO: Create general solution for all interstitial cases
  const isMemberBenefitsInterstitialOpen = useStoreState(
    state => state.ui.isMemberBenefitsInterstitialOpen,
  );

  if (isPageLoading) {
    return (
      <EmotionWrapper>
        <PageLoadingSpinner testId="loading-billing-page" />
      </EmotionWrapper>
    );
  }

  return (
    <EmotionWrapper pageName={pageName}>
      <AppWrapper
        className={hasRebrandFontTreatment ? 'overrides-font-4-2' : ''}
        data-testid={`layout-wrapper-${pageName}`}
        aria-hidden={isMemberBenefitsInterstitialOpen}
        pageName={pageName}
        // if value props is shown, then only add flex box css
        showValueProps={showValueProps}
      >
        {showHeader && <Header showCartButton={pageName !== 'receipt'} />}
        <FlexWrapper showValueProps={showValueProps}>
          <ContentWrapper isContentFullWidth={isContentFullWidth}>
            {children}
            {showFooter && <Footer />}
          </ContentWrapper>
          {showValueProps && <PayPalValueProps />}
        </FlexWrapper>
      </AppWrapper>
    </EmotionWrapper>
  );
};
